import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SummaryBoxesWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
`
export const SummaryBox = styled.li`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 24px 24px;
  min-width: 320px;
  margin-bottom: ${Spacing.S16};
  padding-right: ${Spacing.S24};
  grid-gap: ${Spacing.S4};
`
